export default __webpack_public_path__ + "static/media/i046vk.dc76e584.webp";